<template>
  <MessageBanner
    v-if="visible"
    :headline="t('Reviews.assets.info.headline')"
    type="neutral"
    x
    data-testid="reviews-sponsored-content-banner"
  >
    <div class="mb-8 text-body-s" v-html="t('Reviews.assets.info.message')" />
    <a class="btn-primary-color-s" :href="t('Reviews.assets.info.learnMoreUrl')" target="_blank">{{
      t('Reviews.assets.info.learnMore')
    }}</a>
    <template #action>
      <MdiSvg class="cursor-pointer text-icon-subtlest" :path="mdiClose" size="24" @click="visible = false" />
    </template>
  </MessageBanner>
</template>

<script setup lang="ts">
import { mdiClose } from '@mdi/js'
import { MessageBanner, MdiSvg } from '@ramp106/omrjs-core-ui'
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const visible = ref(true)
</script>
